module.exports = __webpack_public_path__ + "kusamaproject/img/logo.d8295b9a.png";